import { default as Endpoint } from '../../api/Endpoint';
import * as Constants from '../constants';

export function requestGetRules() {
  return {
    type: Constants.REQUEST_GET_RULES
  };
}
export function receiveGetRules(json, error) {
  return {
    type: Constants.RECEIVE_GET_RULES,
    data: json,
    error
  };
}

export function getRules(options = {}) {
  const path = 'ecs/api/rule';
  return new Endpoint(path, requestGetRules, receiveGetRules)
    .withOptions(options)
    .call();
}

export function updateRules(rules) {
  rules = prepareRules(rules);
  return {
    type: Constants.UPDATE_RULES,
    data: { rules }
  };
}

export function revertClassifierRules() {
  return {
    type: Constants.REVERT_CLASSIFIER_RULES
  };
}

export function revertExclusionRules() {
  return {
    type: Constants.REVERT_EXCLUSION_RULES
  };
}

export function revertFatigueRules() {
  return {
    type: Constants.REVERT_FATIGUE_RULES
  };
}

export function revertVarietyRules() {
  return {
    type: Constants.REVERT_VARIETY_RULES
  };
}

export function requestSaveRules() {
  return {
    type: Constants.REQUEST_SAVE_RULES
  };
}
export function receiveSaveRules(json, error) {
  return {
    type: Constants.RECEIVE_SAVE_RULES,
    data: json,
    error
  };
}

export function requestSaveContingency() {
  return {
    type: Constants.REQUEST_SAVE_CONTINGENCY
  };
}
export function receiveSaveContingency(json, error) {
  return {
    type: Constants.RECEIVE_SAVE_CONTINGENCY,
    data: json,
    error
  };
}

export function saveContingencyImage(formData, options = {}) {
  const path = 'ecs/api/rule/contingency_image';
  return new Endpoint(path, requestSaveContingency, receiveSaveContingency)
    .withMethod('PUT')
    .withBody(formData)
    .withOptions(options)
    .call();
}

export function saveContingencyLink(contingency_link, options = {}) {
  const path = 'ecs/api/rule/contingency_link';
  const body = JSON.stringify({ contingency_link });
  return new Endpoint(path, requestSaveContingency, receiveSaveContingency)
    .withMethod('PUT')
    .withBody(body)
    .withOptions(options)
    .call();
}

export function saveRules(rules, options) {
  rules = prepareRules(rules);
  let method = 'PUT';
  let path = `ecs/api/rule/${options.ruleType}`;

  if (options.ruleType === 'setup') {
    method = 'POST';
    path = 'ecs/api/rule/';
  }

  return new Endpoint(path, requestSaveRules, receiveSaveRules)
    .withMethod(method)
    .withBody(JSON.stringify(rules))
    .withOptions(options)
    .call();
}

export function prepareRules(rules) {
  return {
    ...rules,
    exclusion: prepareExclusionRules(rules.exclusion),
    classifier: prepareClassiferRules(rules.classifier)
  };
}

export function prepareClassiferRules(classifier = []) {
  const assetKeys = Object.keys(classifier);
  return assetKeys.map(key => {
    return {
      asset_key: key,
      profile_key: classifier[key].consumerKey,
      must_match: classifier[key].mustMatch,
      apply_to_fallback: classifier[key].applyToFallback
    };
  });
}

export function prepareExclusionRules(exclusion = []) {
  return exclusion.map(obj => ({
    asset_key: obj.assetKey,
    asset_value: obj.assetValue,
    profile_key: obj.consumerKey,
    profile_value: obj.consumerValue
  }));
}
